import { Link, LinkButton } from '@backstage/core-components';
import { Text } from '@backstage/ui';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

export default function WelcomeInfoCard() {
  return (
      <>        
        <Text variant="body-medium">
        Backstage is the home of eXXcellent solutions inner sourcing efforts. It is here to make it easier for engineers to discover tools created by others. Don't reinvent the wheel, search for it.
        </Text>
        <Text variant="body-medium">
        Do you wonder why we choose Backstage in the first place? Find out <Link to="/docs/default/component/exxcellent-backstage-app/">more about eXXcellent Backstage in TechDocs.</Link>.
        </Text>
      </>
  );
}

export const Content = WelcomeInfoCard;
export const Actions = function WelcomeActions() {
  return (
    <>    
    <LinkButton to="/docs/default/system/exxcellent-backstage/getting-started">Getting Started</LinkButton>
    </>
  )
}



export const welcomeWidget = HomePageWidgetBlueprint.make({
  name: 'welcome-widget',
  params: {
    name: 'WelcomeWidget',
    title: 'Welcome to Backstage',    
    description: 'A welcome widget for the homepage',
    components: () =>
      import('./WelcomeInfoCard').then(m => ({
        Content: m.Content,
        Actions: m.Actions
      })),
    layout: {
      height: { minRows: 4 },
      width: { minColumns: 3 },
    }    
  },
}) as any;